import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import Drip from 'drip';
import parseUrl from 'url-parse';
import { Debounce } from '@/utils/debounce';
var TYSS_CATEGORYID = 2; // 体育赛事
var GENERAL_TICKET_TYPE = 2; // 通票类型
var IDCARD_CHECKTICKET_FETCHTYPE = 8; // 身份证检票

/**
 * 判断是否为季票
 *
 * @param {*} categoryId 项目类别
 * @param {*} showType 场次类型
 * @returns (Boolean) 是否为季票
 */
var checkIsSeasonTicket = function checkIsSeasonTicket(categoryId, showType) {
  // 不用了
  return false;
  // 同时满足项目类型为体育赛事 （2） && 场次类型为通票时 （2） 确定为季票
  // return +categoryId === TYSS_CATEGORYID && +showType === GENERAL_TICKET_TYPE
};

/**
 * 判断是否为身份证检票入场方式
 *
 * @param {*} fetchTicketType  取票方式
 */
var isNeedIDCardCheckTicket = function isNeedIDCardCheckTicket(fetchTicketType) {
  return +fetchTicketType === IDCARD_CHECKTICKET_FETCHTYPE;
};

/**
 * 流控code
 */
export var LIMIT_CODE = [1407, 1414];

/**
 * 有刷新间隔的流控code
 */
export var HAS_COUNTTIME_LIMIT_CODE = 1414;

/**
 * 无刷新间隔的流控code
 */
export var NO_COUNTTIME_LIMIT_CODE = 1407;

/**
 * 流控相关配置
 */
export var LimitObjectConfig = {
  limitContent: '前方拥堵 请刷新重试',
  errorContent: '前方拥堵 请稍后重试',
  buttonText: '刷新',
  interval: 3,
  detail: 'https://p0.meituan.net/myvideodistribute/886df2d0f730918e51de7535422519e332107.png',
  // 详情页兜底限流图
  question: 'https://p1.meituan.net/myvideodistribute/9b03d41bd07c6df580d137590821863927882.png',
  // 答题页兜底限流图
  ticket: 'https://p0.meituan.net/myvideodistribute/838200a092ae6304a78df2658e8dccb231951.png',
  // 票档页兜底限流图
  confirm: 'https://p1.meituan.net/myvideodistribute/016304f72a9fa27fcf3ea4ca314a091b21546.png',
  // 确认订单页兜底限流图
  modal: 'https://p0.meituan.net/myvideodistribute/dc644bb52e099d61a7bfe045326228f97319.png',
  // 弹框兜底限流图
  partition: 'https://p1.meituan.net/myvideodistribute/9a0492b6cd0419a6107962c49e8f08cd217315.png',
  // 选择分区兜底限流图
  seats: 'https://p1.meituan.net/myvideodistribute/9ce1325f5069b24bcbe4290f2b954274169053.png',
  // 选择座位兜底限流图
  defaultLimitModalImage: 'https://obj.pipi.cn/festatic/common/image/5178c6ab26fe5ecbf93983731a2f6ff4.png' // 弹框兜底限流图
};

export default {
  checkIsSeasonTicket: checkIsSeasonTicket,
  isNeedIDCardCheckTicket: isNeedIDCardCheckTicket
};
var gotoErrorPage = Debounce(function () {
  Drip.redirect('/myshow/#/error-page');
}, 1000);
export function ajaxErrorProcess(error) {
  var xhr = error.request;
  if (!xhr.status) return;
  var url = xhr._url || xhr.guardReq && xhr.guardReq.url;
  if (url) {
    try {
      var urlObj = parseUrl(url);
      url = "".concat(urlObj.origin).concat(urlObj.pathname);
    } catch (e) {
      console.error(e);
    }
  }
  var errorName = "".concat(xhr.status, " ").concat(url);
  var headers = xhr.getAllResponseHeaders();
  if (headers && headers.indexOf('x-ufe-forbidden') > -1) {
    errorName = "\u9A8C\u7B7E\u5931\u8D25 ".concat(url);
  } else if (headers && headers.indexOf('x-forbid-reason') > -1) {
    errorName = "\u53CD\u722C\u62E6\u622A ".concat(url);
    gotoErrorPage();
  }
  window.Owl && window.Owl.addError({
    name: errorName,
    msg: {
      uaInfo: Drip.constant.uaInfo,
      xhr: {
        request: JSON.stringify(xhr),
        response: JSON.stringify(error.response)
      }
    }
  }, {
    category: 'ajaxError',
    level: 'error'
  });
}
var pageList = ['/pre-ticket', '/ticket-level'];
export function ajaxSuccessLog(res) {
  var _Drip$UA, _res$config, _res$request, _res$request$guardReq;
  if (!((_Drip$UA = Drip.UA) !== null && _Drip$UA !== void 0 && _Drip$UA.isNative)) return;
  var isTargetPage = pageList.some(function (p) {
    var _window$location, _window$location$href;
    return ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : (_window$location$href = _window$location.href) === null || _window$location$href === void 0 ? void 0 : _window$location$href.indexOf(p)) > -1;
  });
  if (!isTargetPage) return;
  var url = ((_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url) || ((_res$request = res.request) === null || _res$request === void 0 ? void 0 : (_res$request$guardReq = _res$request.guardReq) === null || _res$request$guardReq === void 0 ? void 0 : _res$request$guardReq.url);
  if (url) {
    try {
      var urlObj = parseUrl(url);
      url = "".concat(urlObj.origin).concat(urlObj.pathname);
    } catch (e) {}
  }
  try {
    var _window$Logan;
    (_window$Logan = window.Logan) === null || _window$Logan === void 0 ? void 0 : _window$Logan.asyncLog("\u63A5\u53E3\u6210\u529F\u8BF7\u6C42\u65E5\u5FD7-".concat(url, " ").concat(JSON.stringify(res)));
  } catch (e) {
    window.owl && window.owl('addError', e);
  }
}

// 是否设置反爬参数
export function isCrawlEnabled(url) {
  // lion api 白名单
  var lionApiConfig = localStorage.getItem('limitApiLionConfig');
  var lionApiConfigArr = lionApiConfig ? lionApiConfig.split(',') : [];
  var lionApiRegex = new RegExp(lionApiConfigArr.join('|'));

  // 前端路由白名单: 详情页、票档页 旧选座分区页、旧选座页、新选座页、确认订单页。
  var limitRoutes = ['/detail', '/ticket-level', '/movieshoworder/select-seats.html', '/myshowfe/trade/seat', '/movieshoworder/pre-order.html'];
  var limitRouterRegex = new RegExp(limitRoutes.join('|'));
  return lionApiConfigArr.length && lionApiRegex.test(url) || limitRouterRegex.test(location.href);
}